import React, { useLayoutEffect, useState } from 'react';
import * as actionCreators from './../../actions';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Alert, Button, Fade, Modal } from 'react-bootstrap';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { eliminarDiacriticosEs, handleKeyPress, sexOptions, validateEmail, nextQuoteStep } from './../../utilities';
import { yesNoOptions, eliminarDiacriticosEsNum } from './../../utilities';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAddressBook, faCalendarDays, faEnvelope, faFingerprint, faHouse, faMobileAlt, faUser } from '@fortawesome/free-solid-svg-icons';
import Inputs from './../../Components/Inputs';
import SpinnerLoading from "../../Components/SpinnerLoading";

function TitularData({
  codpmpol,
  firstStep,
  titularData,
  saveTitularData,
  provinces,
  cities,
  countries,
  activities,
  resetData,
  handleChange,
  user,
  saveError,
  company,
}) {
  const { errorDescription, alertData, client } = saveError;
  const [mensaje, setMensaje] = useState(null);
  const [show, setShow] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(false);
  const navigate = useNavigate();


  const redireccion = () => {
    switch (firstStep.codsec) {
      case 8: {
        return navigate('/qs/homeData');
      }
      case 32: {
        return navigate('/qs/vehicleData');
      }
      case 64: {
        return navigate('/qs/pets');
      }
      case 12: {
        return navigate('/qs/beneficiaryData');
      }
      case 159: {
        return navigate('/qs/tecnologyData');
      }
      case 161: {
        return navigate('/qs/tecnologyData');
      }
      case 27: {
        return navigate('/qs/confirm');;
      }
      default: {
        return navigate(nextQuoteStep(company, user?.codsuc));
      }
    }
  }

  const handleClose = () => {
    resetData();
    setShow(false);
    navigate("/");
  };
  // const handleShow = () => setShow(true);

  const verifyForm = () => {
    if (titularData.name.length < 2) {
      setMensaje('Revise el nombre');
      return false;
    }
    const regexNombre = /^[A-Za-zÁÉÍÓÚáéíóúÑñ' -]+$/;
    if (!regexNombre.test(titularData.name)) {
      setMensaje('El nombre contiene caracteres no permitidos');
      return false;
    }
    if (!regexNombre.test(titularData.lastname)) {
      setMensaje('El apellido contiene caracteres no permitidos');
      return false;
    }
    if (titularData.address.includes('/') ||
        titularData.address.includes('(') ||
        titularData.address.includes(')') ||
        titularData.address.includes("\\")||
        titularData.address.includes("|") ||
        titularData.address.includes("'") ||
        titularData.address.includes("`") ||
        titularData.address.includes(",")){
      setMensaje('La dirección contiene caracteres no permitidos.');
      return false;
    }
    if (titularData.lastname.length < 2) {
      setMensaje('Revise su apellido');
      return false;
    }
    if (firstStep.codcia === 115 || firstStep.codcia === 122) {
      const regex = new RegExp(`^\\d{2}${firstStep.dni}\\d$`);

      if ((firstStep.cuil.length < 10 || firstStep.cuil.includes("-"))) {
        setMensaje('Revise su CUIL');
        return false;
      }
      if (!regex.test(firstStep.cuil)){
        setMensaje('Revise su CUIL, no coincide con el DNI cargado');
        return false;
      }
    }
    if (/*firstStep.codcia !== 34 && */ titularData.address.length < 2) {
      setMensaje('Revise su domicilio');
      return false;
    }
    // if (firstStep.codcia === 34 && titularData.domicilio?.length < 2) {
    //   setMensaje('Revise su domicilio');
    //   return false;
    // }
    if (!titularData.city) {
      setMensaje('Revise su ciudad');
      return false;
    }
    // if (!titularData.province) {
    //   setMensaje('Revise la provincia');
    //   return false;
    // }
    if (firstStep.codcia === 115 || firstStep.codcia === 122) {
      const regex = new RegExp(`^\\d{2}${firstStep.dni}\\d$`);

      if ((firstStep.cuil.length < 10 || firstStep.cuil.includes("-"))) {
        setMensaje('Revise su CUIL');
        return false;
      }
      if (!regex.test(firstStep.cuil)){
        setMensaje('Revise su CUIL, no coincide con el DNI cargado');
        return false;
      }
    }
    if ((company === 4 || company === 54 || company === 6 || company === 56 || company === 7 || company === 57) || firstStep.codcia === 34 || firstStep.codcia === 122 || firstStep.codcia === 115) {
      if ((!titularData.numAddress && titularData.numAddress !== 0) || isNaN(titularData.numAddress) || Number(titularData.numAddress) < 0 
      || (typeof titularData?.numAddress === 'string' && (titularData.numAddress.includes(".") || titularData.numAddress.includes(",")))) {
        setMensaje('Revise la altura, si no tiene ingrese 0');
        return false;
      }
    }
    if (firstStep.codcia !== 34 && firstStep.codcia !== 1085 && firstStep.codcia !== 122) {
      if (!titularData.phone || titularData.phone[0] === '0' || titularData.phone.length !== 10) {
        setMensaje('Revise el teléfono (sin 0, sin 15 y sin caracteres)');
        return false;
      }
    }
    else {
      if (!titularData.area || titularData.area[0] === '0') {
        setMensaje('Revise el área (No coloque 0)');
        return false;
      }
      if (titularData.phone.startsWith("15")) {
        setMensaje('Revise el teléfono (sin 0, sin 15 y sin caracteres)');
        return false;
      }
      if (titularData.phone.length + titularData.area.length !== 10) {
        setMensaje('El código de área o teléfono es incorrecto');
        return false;
      }
    }
    if (!titularData.genre) {
      setMensaje('Revise el género');
      return false;
    }
    if (firstStep.codcia !== 34) {
      if (titularData.activity === "") {
        setMensaje('Revise la actividad');
        return false;
      }
      if (titularData.expose === "") {
        setMensaje('Revise su respuesta');
        return false;
      }
      if (!titularData.nationality) {
        setMensaje('Revise la nacionalidad');
        return false;
      }
    }
    if (firstStep.codsec === 27){
      if (!firstStep.email || firstStep.email.length < 5) {
        setMensaje('Revise su E-mail');
        return false;
      }
      const valid = validateEmail(firstStep.email);
      if (!valid) {
        setMensaje('Revise su E-mail');
        return false;
      }

    }
    return true;
  }

  const handleSubmit = async () => {
    if (verifyForm()) {
      setError(false);
      setIsLoading(true);
      await saveTitularData({ ...firstStep, ...titularData }, codpmpol);
      setIsLoading(false);
    } else {
      setError(true);
    }
  };

  useEffect(() => {
    handleChange({ step: "titularData", target: { name: 'province', value: firstStep.province } });
    handleChange({ step: "titularData", target: { name: 'city', value: firstStep.city } });
    handleChange({ step: "titularData", target: { name: 'genre', value: titularData.genre } });
    if (firstStep.codcia === 115 || firstStep.codcia === 34) {
      const num = titularData.address.split(" ").pop();
      handleChange({ step: "titularData", target: { name: 'numAddress', value: num } });
      handleChange({ step: "titularData", target: { name: 'address', value: titularData.address.replace(num, "").trim() } });
    }
    if (firstStep.codcia !== 34 && firstStep.codcia !== 1085 && firstStep.codcia !== 122 && !titularData?.phone?.startsWith(titularData.area)) {
      handleChange({ step: "titularData", target: { name: 'phone', value: titularData.area + titularData.phone } });
    }
  }, [])

  useEffect(() => {
    codpmpol === "" && navigate("/");
  }, []);


  useLayoutEffect(() => {
    if (!isLoading && !error) {
      if (!alertData) {
        redireccion();
      } else {
        setShow(true);
      }
    }
  }, [isLoading, error]);

  return (
    <>
      <Fade appear in>
        <div className="qs">
          <div className="container max-shadow mt-3">
            <div className='d-flex flex-column m-0 mb-3 scroll-off'>
              <h1 className='text-start mx-0 mt-3 fs-5 color-title-blue'>PEDIDO DE COBERTURA/DATOS TITULAR</h1>
              <p className='m-0 fw-semibold color-title-blue'>Presupuesto n° {codpmpol}</p>
            </div>
            <br />
            <div className="qs-inputs row row-cols-2">
              {
                (firstStep.codcia === 115 || firstStep.codcia === 122)
                  ? <Inputs
                    title={"Nro. CUIL/CUIT "}
                    name={'cuil'}
                    step={'firstStep'}
                    value={firstStep.cuil}
                    type={"number"}
                    change={(e) => (e.target.value = e.target.value.replace(/\D/g, "").substr(0, 11))}
                    placeholder="Escriba el cuit sin guiones"
                    icon={<FontAwesomeIcon icon={faFingerprint} />}
                  />
                  : <Inputs
                    disabled
                    title={"Nro. DNI"}
                    name={'dni'}
                    value={firstStep.dni}
                    icon={<FontAwesomeIcon icon={faFingerprint} />}
                  />
              }
              <Inputs
                disabled={company !== 1 && company !== 51 && company !== 27 && company !== 77 && company !== 10 && company !== 60}
                title={"E-mail"}
                name={'email'}
                value={firstStep.email}
                step={'firstStep'}
                icon={<FontAwesomeIcon icon={faEnvelope} />}
              />
              <Inputs
                title={"Nombre"}
                name={'name'}
                value={eliminarDiacriticosEs(titularData.name)}
                step={'titularData'}
                icon={<FontAwesomeIcon icon={faUser} />}
                disabled={ (user.disableInputs && (company !== 1 && company !== 51)) || (company == 10 || company == 60)}
              />
              <Inputs
                title={"Apellido"}
                name={'lastname'}
                value={eliminarDiacriticosEs(titularData.lastname)}
                step={'titularData'}
                icon={<FontAwesomeIcon icon={faUser} />}
                disabled={ (user.disableInputs && (company !== 1 && company !== 51)) || (company == 10 || company == 60)}
              />
              {
                firstStep.codcia === 34 ?
                  <Inputs
                    title={"Domicilio"}
                    name={'address'}
                    value={eliminarDiacriticosEsNum(titularData.address)}
                    step={'titularData'}
                    icon={<FontAwesomeIcon icon={faHouse} />}
                    disabled={firstStep.codcia !== 115 ? user.disableInputs : false}
                  /> :
                  <Inputs
                    title={"Domicilio"}
                    name={'address'}
                    value={eliminarDiacriticosEsNum(titularData.address)}
                    step={'titularData'}
                    icon={<FontAwesomeIcon icon={faHouse} />}
                    disabled={firstStep.codcia !== 115 ? (user.disableInputs && company !== 10 && company !== 60) : false}
                  />
              }
              {
                ((company === 4 || company === 54 || company === 6 || company === 56 || company === 7 || company === 57) || firstStep.codcia === 34 || firstStep.codcia === 122 || firstStep.codcia === 115) &&
                <Inputs
                  title={"Número Calle"}
                  name={'numAddress'}
                  value={titularData.numAddress}
                  step={'titularData'}
                  type={'number'}
                  icon={<FontAwesomeIcon icon={faHouse} />}
                  disabled={false}
                />
              }
              {
                (firstStep.codcia === 34 || firstStep.codcia === 1085 || firstStep.codcia === 122) ?
                  <div className='row row-cols-sm-1 row-cols-md-2 row-cols-lg-2 titularData-bbva'>
                    <Inputs
                      title={"Codigo de área"}
                      name={'area'}
                      type={'number'}
                      value={titularData.area}
                      step={'titularData'}
                      icon={<FontAwesomeIcon icon={faMobileAlt} />}
                      disabled={user.disableInputs && (company !== 1 && company !== 51 && company !== 10 && company !== 60)}
                      placeholder={'Ej: 3492, 341'}
                      onKeyDown={handleKeyPress}
                    />
                    <Inputs
                      title={"Teléfono"}
                      name={'phone'}
                      type={'number'}
                      value={titularData.phone}
                      step={'titularData'}
                      icon={<FontAwesomeIcon icon={faMobileAlt} />}
                      disabled={user.disableInputs && (company !== 1 && company !== 51 && company !== 10 && company !== 60)}
                      placeholder={'No coloque el 15'}
                      onKeyDown={handleKeyPress}
                    />
                  </div>
                  :
                  <Inputs
                    title={"Teléfono"}
                    name={'phone'}
                    type={'number'}
                    value={titularData.phone}
                    step={'titularData'}
                    icon={<FontAwesomeIcon icon={faMobileAlt} />}
                    disabled={user.disableInputs && (company !== 1 && company !== 51)}
                  />
              }
              <Inputs
                title={"Género"}
                name={'genre'}
                type={'select'}
                options={sexOptions}
                value={titularData.genre}
                step={'titularData'}
                disabled={firstStep.type === "moto" || (user.disableInputs && company !== 10 && company !== 60)}
              />
              <Inputs
                disabled
                title={"Fecha de Nacimiento"}
                name={'birthday'}
                value={firstStep.birthday}
                icon={<FontAwesomeIcon icon={faCalendarDays} />}
              />
              <Inputs
                title={"Provincia"}
                name={'province'}
                type={'select'}
                options={provinces}
                value={titularData.province}
                step={'titularData'}
                disabled
              />
              <Inputs
                title={"Localidad"}
                name={"city"}
                type={'select'}
                options={cities.filter((c) => c.codprv === firstStep.province)}
                value={titularData.city}
                step={'titularData'}
                disabled
              />
              {
                (firstStep.codcia === 85 || firstStep.codcia === 1085) &&
                <>
                  <Inputs
                    title={"Actividad económica/profesional"}
                    name={'activity'}
                    type={'select'}
                    options={activities.filter(act => act.codcia === firstStep.codcia)}
                    value={titularData.activity}
                    step={'titularData'}
                  />
                  <Inputs
                    title={"Persona políticamente expuesta"}
                    name={'expose'}
                    type={'select'}
                    options={yesNoOptions}
                    value={titularData.expose}
                    step={'titularData'}
                  />
                  <Inputs
                    title={"Nacionalidad"}
                    name={'nationality'}
                    type={'select'}
                    options={countries}
                    value={titularData.nationality}
                    step={'titularData'}
                    disabled={user.disableInputs}
                  />
                </>
              }
            </div>
            {
              error &&
              <Alert className='mt-2' variant={'danger'}>
                {mensaje}
              </Alert>
            }
            <div className='row flexend'>
              <div className="col-sm-6 col-lg-4 offset-lg-4">
                { isLoading ?
                  <SpinnerLoading />
                :
                  <Inputs
                    type={'button'}
                    title="Continuar"
                    onClick={handleSubmit}
                  />
                }
              </div>
            </div>
          </div>
        </div>
      </Fade>
      <Modal show={show} onHide={handleClose}>
        <Modal.Header>
          <Modal.Title>¡Aviso!</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>{errorDescription || client}</p>
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={handleClose} className="main-btn">
            Entiendo
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

function mapStateToProps(state) {
  return {
    titularData: state.mainReducer.titularData,
    firstStep: state.mainReducer.firstStep,
    provinces: state.mainReducer.provinces,
    cities: state.mainReducer.cities,
    countries: state.mainReducer.countries,
    activities: state.mainReducer.activities,
    codpmpol: state.mainReducer.codpmpol,
    user: state.mainReducer.user,
    company: state.mainReducer.company,
    saveError: state.mainReducer.saveError,
  }
};

const mapDispatchToProps = function (dispatch) {
  return bindActionCreators(actionCreators, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(TitularData);
